import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {DateTime} from 'luxon';

import {Markets} from 'models/Market';

export interface MarketsState {
  readonly markets: Markets;
  readonly loading: boolean;
  readonly failed: boolean;
  readonly lastQueryTime?: string;
}

export type MarketsResponse = Markets;

export const initialState: MarketsState = {
  markets: [] as Markets,
  lastQueryTime: undefined,
  loading: true,
  failed: false,
};

const {actions: MarketsActions, reducer: MarketsReducer} = createSlice({
  name: 'markets',
  initialState,
  reducers: {
    clearMarkets() {
      return initialState;
    },
    getMarkets(state) {
      state.loading = true;
      state.failed = false;
    },
    getMarketsCachedSuccess(state) {
      state.loading = false;
      state.failed = false;
    },
    getMarketsSuccess(state, action: PayloadAction<MarketsResponse>) {
      state.loading = false;
      state.failed = false;
      state.lastQueryTime = DateTime.local().toISO();
      state.markets = action.payload;
    },
    getMarketsFailure(state) {
      state.failed = true;
      state.loading = false;
    },
  },
});

export {MarketsActions, MarketsReducer};
export default MarketsReducer;
